export function undefinedToEmptyString(value: string | undefined): string {
  return value ?? '';
}
